import type {CopilotChatOrg} from '@github-ui/copilot-chat-types'
import React, {createContext, use, useMemo} from 'react'

import {useGetTraceState} from './ObservableTraceContext'
import {TraceManager} from './utilities/trace-manager'
import type {TraceAction} from './utilities/trace-reducer'

const TraceManagerContext = createContext<TraceManager | null>(null)

export function TraceManagerProvider({
  apiURL,
  children,
  dispatch,
  ssoOrgs,
}: React.PropsWithChildren<{apiURL: string; dispatch: React.Dispatch<TraceAction>; ssoOrgs: CopilotChatOrg[]}>) {
  const getTraceState = useGetTraceState()
  const traceManager = useMemo(
    () => new TraceManager(dispatch, getTraceState, apiURL, ssoOrgs),
    [apiURL, dispatch, getTraceState, ssoOrgs],
  )

  return <TraceManagerContext value={traceManager}>{children}</TraceManagerContext>
}

export function useTraceManager() {
  const context = use(TraceManagerContext)
  if (context === null) {
    throw new Error('useTraceManager must be used within a TraceManagerProvider')
  }
  return context
}
